import React from 'react';

function About_us() {
  return (
    <div>
    <div className="aboutus">
      <img src="/assets/about_us_banner.png" alt="Hero Background" className="hero-bg" style={{marginLeft:'1%',width:'98%',maxHeight:'500px'}}/>
      <div className="hero-content" style={{marginTop:'20px'}}>
        <div className="hero-text">
          <h1>
            <span className="text-zh">關於我們</span>
            <span className="text-en">About Us</span>
          </h1>
          <p className="hero-description">
            <span className="text-zh">
              我們是一家源自香港、面向全球的專業卡牌評級機構。有別於其他涉獵廣泛的評級公司，我們是全球唯一「專為寶可夢（Pokémon）卡牌服務」的專屬評級中心。正因這份專一，我們追求極致；源於對卡牌的熱愛，我們成就頂尖專業。
<br /><br />集團榮譽<br />
* 「開心企業」標誌：榮獲香港提升快樂指數基金頒發。<br />
* ESG 嘉許獎項：與香港中華廠商聯合會簽署《ESG約章》並榮獲嘉許。  <br />
* 「貼心企業」嘉許獎項：榮獲GS1 Hong Kong 頒發，表揚企業實踐優質消費者服務及秉持誠信。      
            </span>
            <span className="text-en">
              Based in Hong Kong with a global reach, we are a premier professional trading card grading authority. Distinct from multi-category grading companies, we stand as the world’s only grading center exclusively dedicated to Pokémon cards. Our singular focus drives our commitment to perfection, and our passion guarantees unparalleled professional expertise.
<br /><br />Corporate Recognitions<br />
* Happy Company: Awarded by the Promoting Happiness Index Foundation.<br />
* ESG Pledge & Award: Officially signed the ESG Charter and commended by The Chinese Manufacturers' Association of Hong Kong.<br />
* Consumer Caring Scheme Award: Presented by GS1 Hong Kong in recognition of our commitment to delivering consumer-centric services and upholding the highest standards of business integrity.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div className="aboutus">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <span className="text-zh">數十載經驗，守護每一份熱誠</span>
            <span className="text-en">Decades of Expertise</span>
          </h1>
          <p className="hero-description">
            <span className="text-zh">
              我們的專家團隊由多位擁有超過數十年實戰經驗的寶可夢卡收藏家與鑑定專家組成。從 1996 年的第一版日版卡牌到當下的最新系列，我們見證了寶可夢集換式卡牌（PTCG）的每一個巔峰時刻。這份橫跨數十年的深厚積澱，讓我們能精準捕捉每一張卡牌的微小細節，給予最公正、權威的評價。
            </span>
            <span className="text-en">
              Our expert team is composed of seasoned Pokémon card collectors and specialists with decades of hands-on experience. From the original 1996 Japanese Base Set to the latest modern releases, we have witnessed every milestone of the Pokémon Trading Card Game (PTCG). This deep-rooted expertise allows us to capture the smallest details of every card, providing the most impartial and authoritative evaluations.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div className="aboutus">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <span className="text-zh">為什麼選擇我們？</span>
            <span className="text-en">Why Choose Us?</span>
          </h1>
          <p className="hero-description">
            <span className="text-zh">
              絕對的專注： 我們拒絕流水線式的混合評級。這裡只有對寶可夢卡的深刻理解與專項技術，確保每張卡牌都獲得最精準的等級界定。
              <br /> 
              專業鑑定標準： 結合數十年市場經驗，我們自研了一套嚴苛且透明的評級標準，涵蓋印刷偏移、表面刮痕、邊角磨損及中心對比度等核心維度。
              <br />
              提升收藏價值： 獲得我們專業認證的卡牌，不僅是對品相的認可，更是卡牌在二級市場流通時的信心保證。  
            </span>
            <span className="text-en">
              Absolute Specialization: We reject "assembly-line" mixed grading. We offer only deep understanding and specialized techniques for Pokémon cards, ensuring every card receives the most precise grade possible.
              <br />
              Professional Grading Standards: Leveraging decades of market experience, we have developed a rigorous and transparent grading rubric. This covers core dimensions including centering (print alignment), surface scratches, corner wear, and edge condition.
              <br />
              Enhancing Collection Value: A certification from us is more than just a grade—it is a mark of quality and a guarantee of confidence for the secondary market.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div className="aboutus">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <span className="text-zh">我們的使命</span>
            <span className="text-en">Our Mission</span>
          </h1>
          <p className="hero-description">
            <span className="text-zh">
              在寶可夢的世界裡，每一張卡都承載著訓練家的夢想與回憶。我們致力於為每一位收藏家提供最高規格的保護與鑑定服務，讓香港的專業力量成為全球寶可夢愛好者最信賴的後盾。
            </span>
            <span className="text-en">
              In the world of Pokémon, every card carries a trainer’s dreams and memories. We are committed to providing the highest standard of protection services, bringing Hong Kong’s professional excellence to global Pokémon enthusiasts as their most trusted partner.
            </span>
          </p>
        </div>
      </div>
    </div>
    </div>
  );
}

export default About_us;
